module.exports = __webpack_public_path__ + "img/CC.d27df30a.png";